<script>
    export let short = false;
    export let ajankohtaistaUrl = "2024-01-18_kuntalaisille10";
    let title = "10% alennus Kempeleen kunnan työntekijöille";
    let firstPara = "Kempeleen kunnan työntekijät saavat myös vuonna 2024 10% alennuksen.";
</script>
<!--  Ajankohtaista -kirjoitukset koostuu kahdesta osasta. Eka osa "short" on siis muille siuville tuleva lyhennelmä, jossa on artikkelikuva ja lyhyt teksti -->

{#if short}

<div class="blogSummary">
    <a href="/ajankohtaista/{ajankohtaistaUrl}">
        <span class="articleImage"
              style="background-image: url('/svelte-site/img/blog/2015/kelkat.jpg')"></span>
        <span>
        <span class="blogTitle">{title}</span>
        <span class="blogDate">18.01.2024</span>
        <span class="blogShortContent">{firstPara}</span>
    </span>
    </a>
</div>

{:else}
    <div class="blog page">
        <article class="container">
            <h1>{title}</h1>
            <div class="blogDate">18.01.2024</div>

            <p><b>10% alennus kunnan työntekijöille</b></p>
            <p>Dynamosali tarjoaa saman tutun edun kuin aikaisempinakin vuosina. Kunnan työtenkijät saavat siis myös
                tänä vuonna saman 10% alennuksen kuin aiempinakin vuosina. Alennus koskee kaikkia kuukausikortteja
                (päivä, omatoimi, täysjäsenyys) sekä 10 kerran sarjakorttia.</p>
            <p>Alennuksen saa, kunhan näytät meille jonkun dokumentin kassalla.</p>

            <p>Nähdään salilla!</p>


            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <img src='/svelte-site/img/blog/2015/kelkat.jpg' class="img" alt="">
                </div>
            </div>
        </article>
    </div>
{/if}

<style>


    .yhteistyossa {
        clear: both;
        font-size: 85%;
    }

    .yhteistyossa img {
        float: left;
        height: 90px;
        margin: 8px 32px 8px 0;
    }

    @media all and (max-width: 900px) {
        .yhteistyossa img {
            height: 80px;
        }
    }

</style>
